import React from "react";

export default function CategorySkeleton() {
  const skeletonItems = Array(8).fill(0);

  return (
    <div className="flex flex-wrap justify-between gap-4 px-4 sm:px-6 lg:px-8 pt-12">
      {skeletonItems.map((_, index) => (
        <div key={index} className="flex flex-col items-center space-y-3">
          <div className="w-24 h-24 sm:w-36 sm:h-36 bg-gray-200 rounded-full animate-pulse"></div>

          <div className="h-4 w-24 sm:w-28 bg-gray-300 rounded animate-pulse"></div>
        </div>
      ))}
    </div>
  );
}
